import { Text } from '@chakra-ui/react';
import { ComponentProps } from 'components/VirtualizedTable/types';
import { Location, LocationEmployeeItem } from 'generated/models';
import { joinHouseNumber } from 'utils/getHouseNumber';

const AddressCell = ({ row }: ComponentProps<Location & LocationEmployeeItem>) => {
  const address = row?.address ?? row?.location?.address;
  return (
    <Text variant="body.mediumBold" noOfLines={2}>
      {address?.street} {joinHouseNumber(address?.houseNumber, address?.houseOrientationNumber)}
    </Text>
  );
};

export default AddressCell;
